webpackJsonp([114276838955818,60335399758886],{

/***/ 125:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 247:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(263);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(125);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 355:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"form":"src-components-ContactForm----contact-module---form---1Tuzy","input":"src-components-ContactForm----contact-module---input---2__s0","hidden":"src-components-ContactForm----contact-module---hidden---2auRA","textarea":"src-components-ContactForm----contact-module---textarea---_xs_s","test":"src-components-ContactForm----contact-module---test---3zjlt src-components-ContactForm----contact-module---input---2__s0","submit":"src-components-ContactForm----contact-module---submit---3Ngv_","pulse":"src-components-ContactForm----contact-module---pulse---3hUYY"};

/***/ }),

/***/ 251:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactFontawesome = __webpack_require__(10);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _contactModule = __webpack_require__(355);
	
	var _contactModule2 = _interopRequireDefault(_contactModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Contact = function (_React$PureComponent) {
	  _inherits(Contact, _React$PureComponent);
	
	  function Contact(props) {
	    _classCallCheck(this, Contact);
	
	    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props));
	
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.validateField = _this.validateField.bind(_this);
	    _this.validateForm = _this.validateForm.bind(_this);
	
	    _this.state = {
	      name: '',
	      email: '',
	      message: '',
	      nameValid: false,
	      emailValid: false,
	      messageValid: false,
	      formValid: false,
	      submitStatus: 'idle'
	    };
	    return _this;
	  }
	
	  Contact.prototype.handleChange = function handleChange(e) {
	    var _this2 = this;
	
	    var state = {};
	    var _e$target = e.target,
	        name = _e$target.name,
	        value = _e$target.value;
	
	
	    state[name] = value;
	
	    this.setState(state, function () {
	      return _this2.validateField(name, value);
	    });
	  };
	
	  Contact.prototype.validateField = function validateField(name, value) {
	    var _this3 = this;
	
	    var nameValid = this.state.nameValid;
	    var emailValid = this.state.emailValid;
	    var messageValid = this.state.messageValid;
	
	    switch (name) {
	      case 'name':
	        nameValid = value.length > 2;
	        break;
	      case 'message':
	        messageValid = value.length > 2;
	        break;
	      case 'email':
	        emailValid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) !== null;
	        break;
	      default:
	        break;
	    }
	
	    this.setState({
	      nameValid: nameValid,
	      emailValid: emailValid,
	      messageValid: messageValid
	    }, function () {
	      return _this3.validateForm();
	    });
	  };
	
	  Contact.prototype.validateForm = function validateForm() {
	    var formValid = this.state.nameValid && this.state.emailValid && this.state.messageValid;
	
	    this.setState({ formValid: formValid });
	  };
	
	  Contact.prototype.render = function render() {
	    var _React$createElement;
	
	    var submitMessage = '';
	
	    switch (this.state.submitStatus) {
	      case 'waiting':
	        submitMessage = _react2.default.createElement(_reactFontawesome2.default, { icon: ['fas', 'spinner'], pulse: true });
	        break;
	      case 'done':
	        submitMessage = _react2.default.createElement(
	          'span',
	          null,
	          'Thank you ',
	          _react2.default.createElement(_reactFontawesome2.default, { icon: ['fas', 'heart'] })
	        );
	        break;
	      default:
	        submitMessage = _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(_reactFontawesome2.default, { icon: ['fas', 'paper-plane'] }),
	          ' Send'
	        );
	        break;
	    }
	
	    return _react2.default.createElement(
	      'form',
	      {
	        className: _contactModule2.default.form,
	        name: 'contact',
	        action: 'thank-you',
	        'data-netlify-honeypot': 'zip',
	        'data-netlify': 'true'
	      },
	      _react2.default.createElement('input', { type: 'hidden', name: 'form-name', value: 'contact' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-12' },
	          _react2.default.createElement(
	            'label',
	            { className: 'sr-only', htmlFor: 'name' },
	            'Name'
	          ),
	          _react2.default.createElement('input', {
	            className: _contactModule2.default.input,
	            type: 'text',
	            id: 'name',
	            name: 'name',
	            placeholder: 'Name',
	            tabIndex: '1',
	            value: this.state.name,
	            onChange: this.handleChange
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-12' },
	          _react2.default.createElement(
	            'label',
	            { className: 'sr-only', htmlFor: 'id' },
	            'Email address'
	          ),
	          _react2.default.createElement('input', {
	            className: _contactModule2.default.input,
	            type: 'email',
	            id: 'email',
	            name: 'email',
	            placeholder: 'Email',
	            tabIndex: '2',
	            value: this.state.email,
	            onChange: this.handleChange
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-12' },
	          _react2.default.createElement(
	            'label',
	            { className: 'sr-only', htmlFor: 'message' },
	            'Your message'
	          ),
	          _react2.default.createElement('textarea', {
	            className: _contactModule2.default.textarea,
	            id: 'message',
	            name: 'message',
	            rows: '2',
	            placeholder: 'Message',
	            tabIndex: '3',
	            value: this.state.message,
	            onChange: this.handleChange
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _contactModule2.default.hidden },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-12' },
	          _react2.default.createElement(
	            'label',
	            { htmlFor: 'zip' },
	            'Don\'t fill in this field'
	          ),
	          _react2.default.createElement('input', {
	            name: 'zip'
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-12' },
	          _react2.default.createElement(
	            'button',
	            (_React$createElement = { type: 'submit', className: _contactModule2.default.submit, disabled: !this.state.formValid }, _React$createElement['type'] = 'submit', _React$createElement.tabIndex = '6', _React$createElement),
	            submitMessage
	          )
	        )
	      )
	    );
	  };
	
	  return Contact;
	}(_react2.default.PureComponent);
	
	exports.default = Contact;
	module.exports = exports['default'];

/***/ }),

/***/ 357:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"src-components-Footer----footer-module---wrapper---3YxNq","container-fluid":"src-components-Footer----footer-module---container-fluid---TFc5D","row":"src-components-Footer----footer-module---row---2ME7w","reverse":"src-components-Footer----footer-module---reverse---1RYKN","col":"src-components-Footer----footer-module---col---beNfF","col-xs":"src-components-Footer----footer-module---col-xs---2aspk","col-xs-1":"src-components-Footer----footer-module---col-xs-1---eLDsP","col-xs-2":"src-components-Footer----footer-module---col-xs-2---1v0BJ","col-xs-3":"src-components-Footer----footer-module---col-xs-3---2tYeW","col-xs-4":"src-components-Footer----footer-module---col-xs-4---2jfAu","col-xs-5":"src-components-Footer----footer-module---col-xs-5---2qCrS","col-xs-6":"src-components-Footer----footer-module---col-xs-6---2QXfk","col-xs-7":"src-components-Footer----footer-module---col-xs-7---3CFSm","col-xs-8":"src-components-Footer----footer-module---col-xs-8---1SDRk","col-xs-9":"src-components-Footer----footer-module---col-xs-9---lYKhj","col-xs-10":"src-components-Footer----footer-module---col-xs-10---2WWp7","col-xs-11":"src-components-Footer----footer-module---col-xs-11---9qda1","col-xs-12":"src-components-Footer----footer-module---col-xs-12---XTCS8","col-xs-offset-1":"src-components-Footer----footer-module---col-xs-offset-1---3fYWx","col-xs-offset-2":"src-components-Footer----footer-module---col-xs-offset-2---3LlUV","col-xs-offset-3":"src-components-Footer----footer-module---col-xs-offset-3---2S10q","col-xs-offset-4":"src-components-Footer----footer-module---col-xs-offset-4---3K4Qw","col-xs-offset-5":"src-components-Footer----footer-module---col-xs-offset-5---31vfF","col-xs-offset-6":"src-components-Footer----footer-module---col-xs-offset-6---33Gz8","col-xs-offset-7":"src-components-Footer----footer-module---col-xs-offset-7---1r4vL","col-xs-offset-8":"src-components-Footer----footer-module---col-xs-offset-8---255vk","col-xs-offset-9":"src-components-Footer----footer-module---col-xs-offset-9---dxthI","col-xs-offset-10":"src-components-Footer----footer-module---col-xs-offset-10---3Y2a-","col-xs-offset-11":"src-components-Footer----footer-module---col-xs-offset-11---28yjo","col-xs-offset-12":"src-components-Footer----footer-module---col-xs-offset-12---10pNt","start-xs":"src-components-Footer----footer-module---start-xs---HaDxL","center-xs":"src-components-Footer----footer-module---center-xs---3RLTN","end-xs":"src-components-Footer----footer-module---end-xs---3CxH-","top-xs":"src-components-Footer----footer-module---top-xs---1RjJ5","middle-xs":"src-components-Footer----footer-module---middle-xs---YbeY_","bottom-xs":"src-components-Footer----footer-module---bottom-xs---_qEOX","around-xs":"src-components-Footer----footer-module---around-xs---2kZZ1","between-xs":"src-components-Footer----footer-module---between-xs---1iPl9","first-xs":"src-components-Footer----footer-module---first-xs---30TSq","last-xs":"src-components-Footer----footer-module---last-xs---ZUqCR","container":"src-components-Footer----footer-module---container---1oWqn","col-sm":"src-components-Footer----footer-module---col-sm---3SVYw","col-sm-1":"src-components-Footer----footer-module---col-sm-1---1U0Du","col-sm-2":"src-components-Footer----footer-module---col-sm-2---2eEJV","col-sm-3":"src-components-Footer----footer-module---col-sm-3---2PM2s","col-sm-4":"src-components-Footer----footer-module---col-sm-4---3LKWT","col-sm-5":"src-components-Footer----footer-module---col-sm-5---3mWJV","col-sm-6":"src-components-Footer----footer-module---col-sm-6---CvV6_","col-sm-7":"src-components-Footer----footer-module---col-sm-7---3K_PH","col-sm-8":"src-components-Footer----footer-module---col-sm-8---tkORO","col-sm-9":"src-components-Footer----footer-module---col-sm-9---U_PZK","col-sm-10":"src-components-Footer----footer-module---col-sm-10---2bnW7","col-sm-11":"src-components-Footer----footer-module---col-sm-11---3Vl2q","col-sm-12":"src-components-Footer----footer-module---col-sm-12---ixm3d","col-sm-offset-1":"src-components-Footer----footer-module---col-sm-offset-1---3l8jL","col-sm-offset-2":"src-components-Footer----footer-module---col-sm-offset-2---179Dr","col-sm-offset-3":"src-components-Footer----footer-module---col-sm-offset-3---1d5v2","col-sm-offset-4":"src-components-Footer----footer-module---col-sm-offset-4---2y4_O","col-sm-offset-5":"src-components-Footer----footer-module---col-sm-offset-5---pnHVY","col-sm-offset-6":"src-components-Footer----footer-module---col-sm-offset-6---3OTtC","col-sm-offset-7":"src-components-Footer----footer-module---col-sm-offset-7---3YFhk","col-sm-offset-8":"src-components-Footer----footer-module---col-sm-offset-8---2Snw5","col-sm-offset-9":"src-components-Footer----footer-module---col-sm-offset-9---10eBq","col-sm-offset-10":"src-components-Footer----footer-module---col-sm-offset-10---10Q2p","col-sm-offset-11":"src-components-Footer----footer-module---col-sm-offset-11---3YwHu","col-sm-offset-12":"src-components-Footer----footer-module---col-sm-offset-12---2VxqR","start-sm":"src-components-Footer----footer-module---start-sm---2alNq","center-sm":"src-components-Footer----footer-module---center-sm---33vOR","end-sm":"src-components-Footer----footer-module---end-sm---1lkak","top-sm":"src-components-Footer----footer-module---top-sm---ULbl_","middle-sm":"src-components-Footer----footer-module---middle-sm---34S2E","bottom-sm":"src-components-Footer----footer-module---bottom-sm---26X4c","around-sm":"src-components-Footer----footer-module---around-sm---2t88Q","between-sm":"src-components-Footer----footer-module---between-sm---20PKS","first-sm":"src-components-Footer----footer-module---first-sm---35P9C","last-sm":"src-components-Footer----footer-module---last-sm---7kQrm","col-md":"src-components-Footer----footer-module---col-md---d7dgw","col-md-1":"src-components-Footer----footer-module---col-md-1---2gS5v","col-md-2":"src-components-Footer----footer-module---col-md-2---rfr3S","col-md-3":"src-components-Footer----footer-module---col-md-3---1CmTE","col-md-4":"src-components-Footer----footer-module---col-md-4---XRlkp","col-md-5":"src-components-Footer----footer-module---col-md-5---2T4fN","col-md-6":"src-components-Footer----footer-module---col-md-6---2zsKT","col-md-7":"src-components-Footer----footer-module---col-md-7---1OYfa","col-md-8":"src-components-Footer----footer-module---col-md-8---1KAeI","col-md-9":"src-components-Footer----footer-module---col-md-9---1m9BL","col-md-10":"src-components-Footer----footer-module---col-md-10---IxpTe","col-md-11":"src-components-Footer----footer-module---col-md-11---2-SiC","col-md-12":"src-components-Footer----footer-module---col-md-12---AcLHA","col-md-offset-1":"src-components-Footer----footer-module---col-md-offset-1---1K_-8","col-md-offset-2":"src-components-Footer----footer-module---col-md-offset-2---1nk4m","col-md-offset-3":"src-components-Footer----footer-module---col-md-offset-3---477sz","col-md-offset-4":"src-components-Footer----footer-module---col-md-offset-4---2k01F","col-md-offset-5":"src-components-Footer----footer-module---col-md-offset-5---xtG80","col-md-offset-6":"src-components-Footer----footer-module---col-md-offset-6---3c9kR","col-md-offset-7":"src-components-Footer----footer-module---col-md-offset-7---3svJO","col-md-offset-8":"src-components-Footer----footer-module---col-md-offset-8---2CR-s","col-md-offset-9":"src-components-Footer----footer-module---col-md-offset-9---3P4gP","col-md-offset-10":"src-components-Footer----footer-module---col-md-offset-10---30PIE","col-md-offset-11":"src-components-Footer----footer-module---col-md-offset-11---3Xxyx","col-md-offset-12":"src-components-Footer----footer-module---col-md-offset-12---10BF7","start-md":"src-components-Footer----footer-module---start-md---1glv9","center-md":"src-components-Footer----footer-module---center-md---3pXzv","end-md":"src-components-Footer----footer-module---end-md---1BEsl","top-md":"src-components-Footer----footer-module---top-md---3qq4X","middle-md":"src-components-Footer----footer-module---middle-md---8onsp","bottom-md":"src-components-Footer----footer-module---bottom-md---1_JJ1","around-md":"src-components-Footer----footer-module---around-md---2cDVd","between-md":"src-components-Footer----footer-module---between-md---27mKM","first-md":"src-components-Footer----footer-module---first-md---3InHb","last-md":"src-components-Footer----footer-module---last-md---3LNUj","col-lg":"src-components-Footer----footer-module---col-lg---1U-Rc","col-lg-1":"src-components-Footer----footer-module---col-lg-1---3WE1n","col-lg-2":"src-components-Footer----footer-module---col-lg-2---2kSBR","col-lg-3":"src-components-Footer----footer-module---col-lg-3---2mhve","col-lg-4":"src-components-Footer----footer-module---col-lg-4---2QDU2","col-lg-5":"src-components-Footer----footer-module---col-lg-5---3IL-c","col-lg-6":"src-components-Footer----footer-module---col-lg-6---j-RF8","col-lg-7":"src-components-Footer----footer-module---col-lg-7---5F1Ko","col-lg-8":"src-components-Footer----footer-module---col-lg-8---luk3r","col-lg-9":"src-components-Footer----footer-module---col-lg-9---2_aBg","col-lg-10":"src-components-Footer----footer-module---col-lg-10---1xCg1","col-lg-11":"src-components-Footer----footer-module---col-lg-11---6_SaI","col-lg-12":"src-components-Footer----footer-module---col-lg-12---s2xw6","col-lg-offset-1":"src-components-Footer----footer-module---col-lg-offset-1---326vv","col-lg-offset-2":"src-components-Footer----footer-module---col-lg-offset-2---28bfv","col-lg-offset-3":"src-components-Footer----footer-module---col-lg-offset-3---3Ue57","col-lg-offset-4":"src-components-Footer----footer-module---col-lg-offset-4---20Meu","col-lg-offset-5":"src-components-Footer----footer-module---col-lg-offset-5---3wb-k","col-lg-offset-6":"src-components-Footer----footer-module---col-lg-offset-6---3RngZ","col-lg-offset-7":"src-components-Footer----footer-module---col-lg-offset-7---1kf14","col-lg-offset-8":"src-components-Footer----footer-module---col-lg-offset-8---2TqHA","col-lg-offset-9":"src-components-Footer----footer-module---col-lg-offset-9---2BW-j","col-lg-offset-10":"src-components-Footer----footer-module---col-lg-offset-10---l6NWb","col-lg-offset-11":"src-components-Footer----footer-module---col-lg-offset-11---rPs5J","col-lg-offset-12":"src-components-Footer----footer-module---col-lg-offset-12---3dcTz","start-lg":"src-components-Footer----footer-module---start-lg---whl6w","center-lg":"src-components-Footer----footer-module---center-lg---381bc","end-lg":"src-components-Footer----footer-module---end-lg---2EeBD","top-lg":"src-components-Footer----footer-module---top-lg---1jTcm","middle-lg":"src-components-Footer----footer-module---middle-lg---2DKsZ","bottom-lg":"src-components-Footer----footer-module---bottom-lg---3h3T2","around-lg":"src-components-Footer----footer-module---around-lg---33-K1","between-lg":"src-components-Footer----footer-module---between-lg---JQAwU","first-lg":"src-components-Footer----footer-module---first-lg---1f7AA","last-lg":"src-components-Footer----footer-module---last-lg---2X8aR","footer":"src-components-Footer----footer-module---footer---2CvS6","bounceHand":"src-components-Footer----footer-module---bounceHand---lDfrB","bounce":"src-components-Footer----footer-module---bounce---1XCp0","colAbout":"src-components-Footer----footer-module---colAbout---2nV2O","colLinks":"src-components-Footer----footer-module---colLinks---1r4L6","colContact":"src-components-Footer----footer-module---colContact---RaBji"};

/***/ }),

/***/ 253:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactFontawesome = __webpack_require__(10);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _ContactForm = __webpack_require__(251);
	
	var _ContactForm2 = _interopRequireDefault(_ContactForm);
	
	var _Years = __webpack_require__(89);
	
	var _Years2 = _interopRequireDefault(_Years);
	
	var _footerModule = __webpack_require__(357);
	
	var _footerModule2 = _interopRequireDefault(_footerModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer() {
	  return _react2.default.createElement(
	    'div',
	    { className: _footerModule2.default.footer },
	    _react2.default.createElement(
	      'div',
	      { className: _footerModule2.default.container },
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-12 col-sm-6 col-md-4 ' + _footerModule2.default.colAbout },
	          _react2.default.createElement(
	            'h4',
	            null,
	            'About'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'My name is ',
	            _react2.default.createElement(
	              'span',
	              { className: 'author' },
	              'Adrian von Gegerfelt'
	            ),
	            ', and I\'m a web designer and developer with ',
	            _react2.default.createElement(_Years2.default, { since: '2006' }),
	            ' years of experience. With past work in graphics and interaction design, and studies in computer science and human-computer interaction (HCI), I am Designer Slash Developer.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/about-me', className: _footerModule2.default.bounceHand },
	              'Read more ',
	              _react2.default.createElement(_reactFontawesome2.default, { icon: ['fas', 'hand-point-right'] })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-12 col-md-4 ' + _footerModule2.default.colLinks },
	          _react2.default.createElement(
	            'h4',
	            null,
	            'I\'m also on'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: 'https://www.linkedin.com/in/designbyadrian', target: '_blank', title: 'LinkedIn' },
	              _react2.default.createElement(_reactFontawesome2.default, { size: '4x', icon: ['fab', 'linkedin'] })
	            ),
	            '\xA0',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://twitter.com/DesignByAdrian', target: '_blank', title: 'Twitter' },
	              _react2.default.createElement(_reactFontawesome2.default, { size: '4x', icon: ['fab', 'twitter-square'] })
	            ),
	            '\xA0',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://github.com/designbyadrian', target: '_blank', title: 'GitHub' },
	              _react2.default.createElement(_reactFontawesome2.default, { size: '4x', icon: ['fab', 'github-square'] })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-12 col-sm-6 col-md-4 ' + _footerModule2.default.colContact },
	          _react2.default.createElement(
	            'h4',
	            null,
	            'Get in touch'
	          ),
	          _react2.default.createElement(_ContactForm2.default, null)
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-12', style: { textAlign: 'center', lineHeight: '1em' } },
	          _react2.default.createElement(
	            'small',
	            null,
	            '\xA9 Design by Design by Adrian Ltd., all rights reserved.',
	            _react2.default.createElement('br', null),
	            'Built with ',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://reactjs.org/', target: '_blank' },
	              'React'
	            ),
	            ' and ',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://www.gatsbyjs.org', target: '_blank' },
	              'Gatsby'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-12', style: { textAlign: 'center', marginTop: '1em' } },
	          _react2.default.createElement(
	            'a',
	            { href: 'https://www.contentful.com/', rel: 'nofollow', target: '_blank' },
	            _react2.default.createElement('img', { src: 'https://images.contentful.com/fo9twyrwpveg/7Htleo27dKYua8gio8UEUy/0797152a2d2f8e41db49ecbf1ccffdaa/PoweredByContentful_DarkBackground_MonochromeLogo.svg', style: { maxWidth: '100px', width: '100%' }, alt: 'Powered by Contentful' })
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 358:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"src-components-Header----header-module---block---2Uvvl","name":"src-components-Header----header-module---name---1vTUC"};

/***/ }),

/***/ 254:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Logo = __webpack_require__(260);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _headerModule = __webpack_require__(358);
	
	var _headerModule2 = _interopRequireDefault(_headerModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header() {
	  return _react2.default.createElement(
	    _gatsbyLink2.default,
	    { to: '/', className: _headerModule2.default.block },
	    _react2.default.createElement(_Logo2.default, null),
	    _react2.default.createElement(
	      'h1',
	      { className: _headerModule2.default.name },
	      'Design',
	      _react2.default.createElement(
	        'span',
	        null,
	        'by'
	      ),
	      'Adrian'
	    )
	  );
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 260:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _logoModule = __webpack_require__(364);
	
	var _logoModule2 = _interopRequireDefault(_logoModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Logo = function Logo() {
	  return _react2.default.createElement(
	    'div',
	    { className: _logoModule2.default.logo },
	    _react2.default.createElement(
	      'div',
	      { className: _logoModule2.default.pyramid },
	      _react2.default.createElement('div', { className: _logoModule2.default.front }),
	      _react2.default.createElement('div', { className: _logoModule2.default.right }),
	      _react2.default.createElement('div', { className: _logoModule2.default.back }),
	      _react2.default.createElement('div', { className: _logoModule2.default.left })
	    )
	  );
	};
	
	exports.default = Logo;
	module.exports = exports['default'];

/***/ }),

/***/ 364:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"logo":"src-components-Logo----logo-module---logo---323Uu","pyramid":"src-components-Logo----logo-module---pyramid---3jhid","spin":"src-components-Logo----logo-module---spin---1CzN-","side":"src-components-Logo----logo-module---side---oigQ3","front":"src-components-Logo----logo-module---front---xc7eE src-components-Logo----logo-module---side---oigQ3","right":"src-components-Logo----logo-module---right---2qr5H src-components-Logo----logo-module---side---oigQ3","left":"src-components-Logo----logo-module---left---3IZWT src-components-Logo----logo-module---side---oigQ3","back":"src-components-Logo----logo-module---back---3hFNz src-components-Logo----logo-module---side---oigQ3"};

/***/ }),

/***/ 89:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  var date = new Date();
	  var years = date.getFullYear() - parseInt(props.since, 10);
	
	  return _react2.default.createElement(
	    'span',
	    null,
	    years
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 263:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Header = __webpack_require__(254);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(253);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _indexModule = __webpack_require__(367);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	__webpack_require__(582);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TemplateWrapper = function TemplateWrapper(props) {
	
	  var setTheme = function setTheme(theme) {
	    console.log('setTheme(' + theme + ')');
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: _indexModule2.default.flexWrapper },
	    _react2.default.createElement(
	      'div',
	      { className: _indexModule2.default.wrapper },
	      _react2.default.createElement(_Header2.default, null),
	      _react2.default.createElement(
	        'div',
	        { className: _indexModule2.default.container },
	        _react2.default.createElement(
	          'main',
	          null,
	          props.children(_extends({}, props, { setTheme: setTheme }))
	        )
	      )
	    ),
	    _react2.default.createElement(_Footer2.default, null)
	  );
	};
	
	TemplateWrapper.propTypes = {
	  children: _propTypes2.default.func
	};
	
	exports.default = TemplateWrapper;
	module.exports = exports['default'];

/***/ }),

/***/ 367:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"src-layouts----index-module---wrapper---2aAhA","container-fluid":"src-layouts----index-module---container-fluid---EHvbb","row":"src-layouts----index-module---row---1sWTM","reverse":"src-layouts----index-module---reverse---3-qAC","col":"src-layouts----index-module---col---3kse6","col-xs":"src-layouts----index-module---col-xs---3tlIi","col-xs-1":"src-layouts----index-module---col-xs-1---2JRn5","col-xs-2":"src-layouts----index-module---col-xs-2---33AD3","col-xs-3":"src-layouts----index-module---col-xs-3---iH7HY","col-xs-4":"src-layouts----index-module---col-xs-4---CCMlc","col-xs-5":"src-layouts----index-module---col-xs-5---1FaLz","col-xs-6":"src-layouts----index-module---col-xs-6---OWk5R","col-xs-7":"src-layouts----index-module---col-xs-7---rpXQY","col-xs-8":"src-layouts----index-module---col-xs-8---LfRh8","col-xs-9":"src-layouts----index-module---col-xs-9---3nkFh","col-xs-10":"src-layouts----index-module---col-xs-10---PW75H","col-xs-11":"src-layouts----index-module---col-xs-11---H8jQr","col-xs-12":"src-layouts----index-module---col-xs-12---2fMw1","col-xs-offset-1":"src-layouts----index-module---col-xs-offset-1---u96Da","col-xs-offset-2":"src-layouts----index-module---col-xs-offset-2---3htfV","col-xs-offset-3":"src-layouts----index-module---col-xs-offset-3---Y8cye","col-xs-offset-4":"src-layouts----index-module---col-xs-offset-4---2GUlS","col-xs-offset-5":"src-layouts----index-module---col-xs-offset-5---ymQoX","col-xs-offset-6":"src-layouts----index-module---col-xs-offset-6---1KdGw","col-xs-offset-7":"src-layouts----index-module---col-xs-offset-7---1-ckl","col-xs-offset-8":"src-layouts----index-module---col-xs-offset-8---LcM7c","col-xs-offset-9":"src-layouts----index-module---col-xs-offset-9---34JGw","col-xs-offset-10":"src-layouts----index-module---col-xs-offset-10---gZEbV","col-xs-offset-11":"src-layouts----index-module---col-xs-offset-11---3j09R","col-xs-offset-12":"src-layouts----index-module---col-xs-offset-12---TA3Gr","start-xs":"src-layouts----index-module---start-xs---2ti84","center-xs":"src-layouts----index-module---center-xs---2nw-_","end-xs":"src-layouts----index-module---end-xs---bbqqF","top-xs":"src-layouts----index-module---top-xs---2ZRKl","middle-xs":"src-layouts----index-module---middle-xs---30Afq","bottom-xs":"src-layouts----index-module---bottom-xs---yzDcB","around-xs":"src-layouts----index-module---around-xs---22Jp1","between-xs":"src-layouts----index-module---between-xs---2PNGZ","first-xs":"src-layouts----index-module---first-xs---1angv","last-xs":"src-layouts----index-module---last-xs---5NXnE","container":"src-layouts----index-module---container---2XoGc","col-sm":"src-layouts----index-module---col-sm---XvpHz","col-sm-1":"src-layouts----index-module---col-sm-1---1MODq","col-sm-2":"src-layouts----index-module---col-sm-2---3cVPv","col-sm-3":"src-layouts----index-module---col-sm-3---2d0me","col-sm-4":"src-layouts----index-module---col-sm-4---hb5FJ","col-sm-5":"src-layouts----index-module---col-sm-5---1Z4Dz","col-sm-6":"src-layouts----index-module---col-sm-6---1aGZk","col-sm-7":"src-layouts----index-module---col-sm-7---2lr3W","col-sm-8":"src-layouts----index-module---col-sm-8---266Nm","col-sm-9":"src-layouts----index-module---col-sm-9---2sWU6","col-sm-10":"src-layouts----index-module---col-sm-10---23z9S","col-sm-11":"src-layouts----index-module---col-sm-11---2SD6S","col-sm-12":"src-layouts----index-module---col-sm-12---IFsVE","col-sm-offset-1":"src-layouts----index-module---col-sm-offset-1---1R1CS","col-sm-offset-2":"src-layouts----index-module---col-sm-offset-2---3e8gC","col-sm-offset-3":"src-layouts----index-module---col-sm-offset-3---3BLGU","col-sm-offset-4":"src-layouts----index-module---col-sm-offset-4---2NnNs","col-sm-offset-5":"src-layouts----index-module---col-sm-offset-5---345S1","col-sm-offset-6":"src-layouts----index-module---col-sm-offset-6---2T1OW","col-sm-offset-7":"src-layouts----index-module---col-sm-offset-7---3xEGt","col-sm-offset-8":"src-layouts----index-module---col-sm-offset-8---2qcBT","col-sm-offset-9":"src-layouts----index-module---col-sm-offset-9---1AGni","col-sm-offset-10":"src-layouts----index-module---col-sm-offset-10---93Tyh","col-sm-offset-11":"src-layouts----index-module---col-sm-offset-11---Xp8bj","col-sm-offset-12":"src-layouts----index-module---col-sm-offset-12---1vKPA","start-sm":"src-layouts----index-module---start-sm---13klS","center-sm":"src-layouts----index-module---center-sm---1VRj4","end-sm":"src-layouts----index-module---end-sm---2sejK","top-sm":"src-layouts----index-module---top-sm---1caCi","middle-sm":"src-layouts----index-module---middle-sm---1sY-Y","bottom-sm":"src-layouts----index-module---bottom-sm---3MC7R","around-sm":"src-layouts----index-module---around-sm---1ANTI","between-sm":"src-layouts----index-module---between-sm---3zXG9","first-sm":"src-layouts----index-module---first-sm---2e1ba","last-sm":"src-layouts----index-module---last-sm---R0vBL","col-md":"src-layouts----index-module---col-md---3l9LE","col-md-1":"src-layouts----index-module---col-md-1---3Mgpi","col-md-2":"src-layouts----index-module---col-md-2---oF7oA","col-md-3":"src-layouts----index-module---col-md-3---1B1mL","col-md-4":"src-layouts----index-module---col-md-4---_1B9V","col-md-5":"src-layouts----index-module---col-md-5---1MD1z","col-md-6":"src-layouts----index-module---col-md-6---38ZEF","col-md-7":"src-layouts----index-module---col-md-7---2qguG","col-md-8":"src-layouts----index-module---col-md-8---3XkkX","col-md-9":"src-layouts----index-module---col-md-9---3QgMp","col-md-10":"src-layouts----index-module---col-md-10---1I7vn","col-md-11":"src-layouts----index-module---col-md-11---3xqoy","col-md-12":"src-layouts----index-module---col-md-12---25xga","col-md-offset-1":"src-layouts----index-module---col-md-offset-1---2eNwF","col-md-offset-2":"src-layouts----index-module---col-md-offset-2---hzkge","col-md-offset-3":"src-layouts----index-module---col-md-offset-3---3YW2N","col-md-offset-4":"src-layouts----index-module---col-md-offset-4---ZsOa0","col-md-offset-5":"src-layouts----index-module---col-md-offset-5---K_i4M","col-md-offset-6":"src-layouts----index-module---col-md-offset-6---1duuM","col-md-offset-7":"src-layouts----index-module---col-md-offset-7---2MHoe","col-md-offset-8":"src-layouts----index-module---col-md-offset-8---1YA_E","col-md-offset-9":"src-layouts----index-module---col-md-offset-9---1zA71","col-md-offset-10":"src-layouts----index-module---col-md-offset-10---2ooD5","col-md-offset-11":"src-layouts----index-module---col-md-offset-11---B8Frv","col-md-offset-12":"src-layouts----index-module---col-md-offset-12---24j9D","start-md":"src-layouts----index-module---start-md---39BZB","center-md":"src-layouts----index-module---center-md---BRpHv","end-md":"src-layouts----index-module---end-md---3Y9Df","top-md":"src-layouts----index-module---top-md---gKoNR","middle-md":"src-layouts----index-module---middle-md---3QUe5","bottom-md":"src-layouts----index-module---bottom-md---PM4fZ","around-md":"src-layouts----index-module---around-md---3xt-t","between-md":"src-layouts----index-module---between-md---1Gjxi","first-md":"src-layouts----index-module---first-md---2kVMB","last-md":"src-layouts----index-module---last-md---IcoP1","col-lg":"src-layouts----index-module---col-lg---2HRdI","col-lg-1":"src-layouts----index-module---col-lg-1---CUaNt","col-lg-2":"src-layouts----index-module---col-lg-2---W5MI9","col-lg-3":"src-layouts----index-module---col-lg-3---3RBts","col-lg-4":"src-layouts----index-module---col-lg-4---21G_g","col-lg-5":"src-layouts----index-module---col-lg-5---3Xki2","col-lg-6":"src-layouts----index-module---col-lg-6---2sAha","col-lg-7":"src-layouts----index-module---col-lg-7---1ZU5g","col-lg-8":"src-layouts----index-module---col-lg-8---2DuKJ","col-lg-9":"src-layouts----index-module---col-lg-9---2SPEd","col-lg-10":"src-layouts----index-module---col-lg-10---189Cn","col-lg-11":"src-layouts----index-module---col-lg-11---3jBaU","col-lg-12":"src-layouts----index-module---col-lg-12---2i6YE","col-lg-offset-1":"src-layouts----index-module---col-lg-offset-1---2WD_3","col-lg-offset-2":"src-layouts----index-module---col-lg-offset-2---2ptvc","col-lg-offset-3":"src-layouts----index-module---col-lg-offset-3---LdhF4","col-lg-offset-4":"src-layouts----index-module---col-lg-offset-4---3QyTE","col-lg-offset-5":"src-layouts----index-module---col-lg-offset-5---1vBGl","col-lg-offset-6":"src-layouts----index-module---col-lg-offset-6---zJiUG","col-lg-offset-7":"src-layouts----index-module---col-lg-offset-7---1kFow","col-lg-offset-8":"src-layouts----index-module---col-lg-offset-8---JYiDt","col-lg-offset-9":"src-layouts----index-module---col-lg-offset-9---ZLMu4","col-lg-offset-10":"src-layouts----index-module---col-lg-offset-10---12qh_","col-lg-offset-11":"src-layouts----index-module---col-lg-offset-11---1Gs6X","col-lg-offset-12":"src-layouts----index-module---col-lg-offset-12---1-lK0","start-lg":"src-layouts----index-module---start-lg---UBNcH","center-lg":"src-layouts----index-module---center-lg---1PcNR","end-lg":"src-layouts----index-module---end-lg---OxTWP","top-lg":"src-layouts----index-module---top-lg---3G8Kb","middle-lg":"src-layouts----index-module---middle-lg---2Sg9l","bottom-lg":"src-layouts----index-module---bottom-lg---3WZVC","around-lg":"src-layouts----index-module---around-lg---2UXQN","between-lg":"src-layouts----index-module---between-lg---3gzFi","first-lg":"src-layouts----index-module---first-lg---1sUy_","last-lg":"src-layouts----index-module---last-lg---QHBjX","flexWrapper":"src-layouts----index-module---flexWrapper---2hw5e"};

/***/ }),

/***/ 582:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-b5168a36a1f646e5ca3e.js